export default {
  title: 'Sites',
  description: 'Each site is a geofence. Paired phones inside it count as on site.',
  newSite: 'New site',
  searchPlaceholder: 'Search sites…',
  searchLabel: 'Search sites',
  showInactive: 'Show inactive',
  countOne: '{count} site',
  countOther: '{count} sites',
  emptySearchTitle: 'No sites match',
  emptyTitle: 'No sites yet',
  emptySearchMessage: 'Nothing matches "{search}".',
  emptyMessage: 'Create a site to start tracking attendance.',
  address: 'Address',
  radius: 'Radius',
  timeZone: 'Time zone',
  noAddress: 'No address',
  active: 'Active',
  inactive: 'Inactive',
  deactivate: 'Deactivate',
  reactivate: 'Reactivate',
  deactivateTitle: 'Deactivate site',
  deactivateMessage: '"{name}" will stop appearing to devices and site managers. Attendance history is kept.',
  deactivated: 'Site deactivated.',
  reactivated: 'Site reactivated.',
  details: 'Details',
  siteName: 'Site name',
  addressHint: 'Shown to managers on the dashboard. Pick a suggestion to place it on the map.',
  timeZoneHint: 'Daily reports run midnight to midnight in this zone.',
  geofence: 'Geofence',
  geofenceDescription: 'Where the site is and how far from its centre still counts as on site.',
  latitude: 'Latitude',
  longitude: 'Longitude',
  useMyLocation: 'Use my location',
  activeCheckbox: 'Active. Visible to phones and site managers',
  placeOnMap: 'Place the site on the map to continue.',
  finishPolygon: 'Finish drawing the polygon to continue.',
  derivedLatitude: 'Centre latitude (derived)',
  derivedLongitude: 'Centre longitude (derived)',
  derivedHint: 'Worked out from the polygon.',
  createDescription: 'Name the site, then place its geofence on the map.',
  creating: 'Creating…',
  createSite: 'Create site',
  created: 'Site created.',
  editDescription: 'Edit site',
  updated: 'Site updated.',
  moreTitle: 'Contacts, files, jobs and notifications',
  moreDescription: 'These are kept on the site page, next to the live view.',
  openContacts: 'Contacts',
  openFiles: 'Files and plans',
  openJobs: 'Jobs',
  openNotifications: 'Notifications',
}
